export const contentMaxWidth = 1920
export const appLoaderHeight = 4
/** Height of the unified app header bar (single row, both platforms). */
export const headerBarHeight = 56
